import React from 'react';
import { ArticleBlockContentGridCol } from '../ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../../BlockContent.utils';
import { CompetitionSerializerProps } from './Competition.types';
import { CompetitionBlock } from './CompetitionBlock';

export const CompetitionSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: CompetitionSerializerProps) => (
      <ArticleBlockContentGridCol>
        <CompetitionBlock documentId={value._ref} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: CompetitionSerializerProps) => <CompetitionBlock documentId={value._ref} />;
};
